export default __webpack_public_path__ + "static/media/then.531891f1.png";